import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';
import { jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled

import { Box, xcss } from '@atlaskit/primitives';
import { useElementSize } from '../../hooks/useElementSize';
import { FooterAIBrand } from './components/FooterAIBrand';
import { FooterDisclaimer } from './components/FooterDisclaimer';
import { AI_BREAKPOINTS, ROVO_BREAKPOINTS } from './constants';
var footerStyles = xcss({
  display: 'flex',
  flexWrap: 'wrap',
  paddingLeft: 'space.200',
  paddingRight: 'space.200',
  paddingTop: 'space.100',
  paddingBottom: 'space.100',
  gap: 'space.050',
  borderTopLeftRadius: 'unset',
  borderTopRightRadius: 'unset',
  backgroundColor: 'elevation.surface',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'color.border',
  alignItems: 'center',
  justifyContent: 'space-between'
});
export function Footer(_ref) {
  var brand = _ref.brand,
    showDisclaimer = _ref.showDisclaimer,
    disclaimer = _ref.disclaimer;
  var _useElementSize = useElementSize(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    setElement = _useElementSize2[0],
    width = _useElementSize2[1].width;
  var appearance = useMemo(function () {
    if (brand === 'atlassian-intelligence') {
      if (width < AI_BREAKPOINTS.medium) {
        return 'small';
      }
      if (width < AI_BREAKPOINTS.large) {
        return 'medium';
      }
      return 'large';
    } else {
      if (width < ROVO_BREAKPOINTS.medium) {
        return 'small';
      }
      if (width < ROVO_BREAKPOINTS.large) {
        return 'medium';
      }
      return 'large';
    }
  }, [width, brand]);
  return jsx(Box, {
    ref: setElement,
    xcss: footerStyles
  }, showDisclaimer ? jsx(FooterDisclaimer, {
    disclaimer: disclaimer,
    appearance: appearance
  }) : jsx(Box, null), jsx(FooterAIBrand, {
    brand: brand,
    appearance: appearance
  }));
}